import React, { PureComponent } from 'react'
import {
  heightPercentageToDP as heightPercentage,
  widthPercentageToDP as widthPercentage,
} from '../../../Utils/ResponsiveScreen'
import { KTColors } from '../../Constants/KTColors'
import { fonts } from '../../Constants/theme'
import StoryContentView from './StoryContentView'
import ReactCardFlip from 'react-card-flip'
import AwsConfig from '../../../Config/AwsConfig'

const styles = {
  container: {
    flex: 1,
    width: '100%',
  },
  flipToStoryMain: {},
  cardContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  card: {
    width: widthPercentage('100'),
    height: heightPercentage('100'),
    shadowColor: 'rgba(0,0,0,0.5)',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    justifyContent: 'center',
    alignItems: 'center',
    shadowOpacity: 0.5,
    padding: widthPercentage('5%'),
  },

  questionText: {
    textAlign: 'center',
    fontFamily: fonts.fontFamilyPoppinsLight,
    fontSize: heightPercentage('2.8%'),
    lineHeight: heightPercentage('3.6%'),
    fontWeight: 'bold',
    marginBottom: heightPercentage('1%'),
  },
  buttonText: {
    fontSize: heightPercentage('2.4%'),
    lineHeight: heightPercentage('2.6%'),
    fontFamily: fonts.fontFamilyPoppinsLight,
  },
  button: {
    borderWidth: 0.8,
    opacity: 0.8,
    width: widthPercentage('90%'),
    marginTop: heightPercentage('1.5%'),
  },

  questionsContentPoster: {
    height: heightPercentage('100'),
    resizeMode: 'cover',
  },
  questionContainerBorder: {
    backgroundColor: 'rgba(0, 0, 0, 0.36)',
    padding: widthPercentage('2.5%'),
    borderRadius: 10,
    borderWidth: 2,
  },
  titleBgColorStyle: {
    width: widthPercentage('90%'),
    justifyContent: 'center',
    alignItems: 'center',
    left: widthPercentage('5%'),
    position: 'absolute',
    backgroundColor: 'rgba(0, 0, 0, 0.36)',
    padding: widthPercentage('2.5%'),
    borderRadius: 10,
    borderWidth: 2,
  },
  titleNoBgColor: {
    width: widthPercentage('90%'),
    justifyContent: 'center',
    alignItems: 'center',
    left: widthPercentage('5%'),
    position: 'absolute',
    padding: widthPercentage('2.5%'),
  },
}

class FlipToStoryView extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isFlipped: false,
    }
  }

  flipCard = () => {
    this.setState({ isFlipped: !this.state.isFlipped })
  }

  reverseFlipCard = () => {
    this.setState({ isFlipped: !this.state.isFlipped })
  }

  render() {
    const { content, contentSelectedLangVal } = this.props
    const {
      coverStoryOriginalImages,
      coverStoryImages,
      contentTitlePosition,
      textColor,
      backGroundTitle,
    } = content.contentMetaInfo.coverStoryDetails.flipToStoryDetails
    const { flipToStoryDetails } = content.contentMetaInfo.coverStoryDetails
    const topPosition = contentTitlePosition ? contentTitlePosition : 50
    const titleColor = textColor ? textColor : KTColors.white
    const titleBgColor = backGroundTitle ? backGroundTitle : false

    const coverStoryImageAvailable = coverStoryImages && coverStoryImages[0]
    let cdnurl = AwsConfig.cdn_url
    const imageWithCdn = coverStoryImageAvailable ?
      coverStoryImages[0].image.includes(cdnurl)
        ? coverStoryImages[0].image
        : cdnurl + coverStoryImages[0].image
      : ""
    const coverStoryOriginalImagesExist = coverStoryOriginalImages &&
      coverStoryOriginalImages[0] &&
      coverStoryOriginalImages[0].imageValue

    const coverStoryImage = coverStoryImageAvailable
      ? coverStoryOriginalImagesExist
        ? coverStoryOriginalImages[0].imageValue
        : imageWithCdn
      : ''
    const flipToStoryBgImg = coverStoryImage
    return (
      <div style={{ flex: 1, height: heightPercentage('100%') }}>
        <div>
          <ReactCardFlip isFlipped={this.state.isFlipped} flipDirection='horizontal'>
            <div
              onClick={() => this.flipCard()}
              style={{
                backgroundImage: `url(${flipToStoryBgImg})`,
                height: heightPercentage('100%'),
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
              }}
            >
              <div
                style={
                  titleBgColor
                    ? {
                      ...styles.titleBgColorStyle,
                      ...{ top: heightPercentage(`${topPosition}%`) },
                    }
                    : { ...styles.titleNoBgColor, ...{ top: heightPercentage(`${topPosition}%`) } }
                }
              >
                <div style={styles.questionTextContainer}>
                  <p
                    style={{
                      fontSize: heightPercentage('2.2%'),
                      color: titleColor,
                      fontFamily: fonts.fontFamilyPoppinsLight,
                      textAlign: 'center',
                    }}
                  >
                    {flipToStoryDetails[`coverStoryTitle_${contentSelectedLangVal}`]}
                  </p>
                </div>
              </div>
            </div>
            <StoryContentView
              content={content}
              contentType={'CoverStory'}
              title={flipToStoryDetails[`coverStoryTitle_${contentSelectedLangVal}`]}
              cardDescription={
                flipToStoryDetails[`coverStoryCardDescription_${contentSelectedLangVal}`]
              }
              cardImages={
                flipToStoryDetails.coverStoryCardOriginalImages
                  ? flipToStoryDetails.coverStoryCardOriginalImages
                  : flipToStoryDetails.coverStoryCardImages
              }
              showBottomLogo={this.props.showBottomLogo}
              flipCard={this.reverseFlipCard}
              closeButton={true}
              changeCardTextColor={this.props.changeCardTextColor}
              preview={this.props.preview}
              coverStoryVideoURL={flipToStoryDetails?.coverStoryVideoURL}
              contentNewLinkDetails={this.props.contentNewLinkDetails}
            />
          </ReactCardFlip>
        </div>
      </div>
    )
  }
}

export default FlipToStoryView
